import { connect } from 'react-redux';
import KeyFigure from './key-figure';

import {
  selectReport,
} from '../../../../../reducers/reports.reducers';

const mapStateToProps = (state, ownProps) => {
  const { reports } = state.reports;
  const { keyFigure: { linkedWidgets, linkedReports } } = ownProps;

  if (linkedWidgets) {
    const linkedReport = reports.find(r => r.reportItems.find(w => linkedWidgets.includes(w.reportWidgetID)));
    if (linkedReport) {
      return { linkedReport };
    }
  }

  if (linkedReports) {
    const linkedReport = reports.find(l => linkedReports.includes(l.reportID));
    if (linkedReport) {
      return { linkedReport };
    }
  }

  return {};
};

const mapDispatchToProps = dispatch => ({
  selectReport: id => dispatch(selectReport(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(KeyFigure);
